<template>
  <div class="the-regular-basic">
    <div class="left-wrap">
      <div class="left-title">Weeks</div>

      <!-- <a-button style="margin-bottom: 10px;" @click="handleWeek">
        {{ $t('handle.edit') }}
      </a-button> -->

      <!-- 表格 -->
      <a-table
        style="width: 180px"
        size="middle"
        :showHeader="false"
        :rowKey="(record) => record.id"
        :loading="weekTableLoading"
        :dataSource="weekDataSource"
        :pagination="false"
        :rowClassName="(record) => (weekId === record.id ? 'selected-row' : '')"
        :customRow="
          (record) => {
            return {
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  if (weekId === record.id) {
                    return
                  }
                  editGrades = false
                  weekInfo = record
                  weekId = record.id
                  submitDisabled = record.submitStatus === 1
                },
              },
            }
          }
        "
      >
        <a-table-column
          :width="150"
          title="weeks"
          dataIndex="weeks"
        ></a-table-column>

        <a-table-column title="submitStatus" dataIndex="submitStatus">
          <template slot-scope="submitStatus">
            <a-icon v-if="submitStatus === 1" type="check" />
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="right-wrap" v-if="!!weekId">
      <div class="grade-title">
        {{ weekInfo.weeks }}
        <div>
          <template v-if="handleRightsList.includes('编辑')">
            <a-button
              v-if="!editGrades"
              class="margin--right"
              :disabled="submitDisabled"
              @click="handleEdit"
            >
              {{ $t('handle.edit') }}
            </a-button>
            <a-button
              class="margin--right"
              v-if="editGrades"
              :disabled="submitDisabled"
              @click="handleSaveGrades"
            >
              {{ $t('handle.save') }}
            </a-button>
            <a-button
              class="margin--right"
              v-if="editGrades"
              :disabled="submitDisabled"
              @click="handleCancel"
            >
              {{ $t('handle.cancel') }}
            </a-button>
            <a-button
              v-if="!editGrades"
              :disabled="submitDisabled"
              @click="handleSubmit"
            >
              {{ $t('handle.submit') }}
            </a-button>
          </template>
        </div>
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :scroll="{ x: 900 }"
        :rowKey="(record) => record.id"
        :loading="studentTableLoading"
        :dataSource="studentDataSource"
        :pagination="false"
      >
        <a-table-column
          :width="120"
          title="#"
          dataIndex="studentNo"
          :sorter="sorterStudentNo"
        ></a-table-column>

        <a-table-column
          :width="65"
          :title="$t('public.name')"
          dataIndex="name"
          :sorter="sorterName"
        ></a-table-column>

        <a-table-column
          :width="140"
          :title="$t('public.englishName')"
          dataIndex="englishName"
          :sorter="sorterEnglishName"
        >
          <template slot-scope="englishName, record">
            {{ record.surname }} {{ record.givenName }} ({{
              record.englishName
            }})
          </template>
        </a-table-column>

        <a-table-column
          :width="86"
          :title="$t('grades.attendance')"
          dataIndex="basicGrade.attendance"
        >
          <template slot-scope="attendance, record">
            <a-input-number
              style="width: 70px"
              :min="0"
              :max="100"
              :step="0.1"
              :precision="1"
              v-if="editGrades"
              :defaultValue="
                attendance ? Number(attendance) : attendance == 0 ? 0 : 100
              "
              @change="(value) => handleChange(value, record.id, 'attendance')"
            />
            <template v-else>
              {{
                record.basicGrade && record.basicGrade.recordStatus === 4
                  ? 'N/A'
                  : attendance
              }}
            </template>
          </template>
        </a-table-column>

        <a-table-column
          :width="86"
          :title="$t('grades.assignments')"
          dataIndex="basicGrade.assignments"
        >
          <template slot-scope="assignments, record">
            <a-input-number
              style="width: 70px"
              :min="0"
              :max="100"
              :step="0.1"
              :precision="1"
              v-if="editGrades"
              :defaultValue="
                assignments ? Number(assignments) : assignments == 0 ? 0 : 100
              "
              @change="(value) => handleChange(value, record.id, 'assignments')"
            />
            <template v-else>
              {{
                record.basicGrade && record.basicGrade.recordStatus === 4
                  ? 'N/A'
                  : assignments
              }}
            </template>
          </template>
        </a-table-column>

        <a-table-column
          :width="86"
          :title="$t('grades.participation')"
          dataIndex="basicGrade.participation"
        >
          <template slot-scope="participation, record">
            <a-input-number
              style="width: 70px"
              :min="0"
              :max="100"
              :step="0.1"
              :precision="1"
              v-if="editGrades"
              :defaultValue="
                participation
                  ? Number(participation)
                  : participation == 0
                  ? 0
                  : 100
              "
              @change="
                (value) => handleChange(value, record.id, 'participation')
              "
            />
            <template v-else>
              {{
                record.basicGrade && record.basicGrade.recordStatus === 4
                  ? 'N/A'
                  : participation
              }}
            </template>
          </template>
        </a-table-column>

        <a-table-column
          :title="$t('public.comments')"
          dataIndex="basicGrade.comment"
        >
          <template slot-scope="comment, record">
            <a-input
              v-if="editGrades"
              :value="comment"
              @change="
                (e) => handleChange(e.target.value, record.id, 'comment')
              "
            />
            <template v-else>
              {{ comment }}
            </template>
          </template>
        </a-table-column>

        <a-table-column
          :width="100"
          :title="$t('public.operate')"
          align="right"
          dataIndex="handles"
          v-if="handleRightsList.includes('编辑')"
        >
          <template slot-scope="handles, record">
            <a
              href="javascript:;"
              v-if="record.basicGrade.basicGradeStatus === 0"
              @click="editItem(record)"
            >
              {{ $t('handle.edit') }}
            </a>
            <a
              href="javascript:;"
              v-if="
                record.basicGrade &&
                (record.basicGrade.basicGradeStatus === 1 ||
                  record.basicGrade.basicGradeStatus === 2 ||
                  record.basicGrade.basicGradeStatus === 4)
              "
              @click="editItem(record)"
            >
              {{ $t('handle.reedit') }}
            </a>
            <span
              class="grade-status"
              v-else-if="
                record.basicGrade && record.basicGrade.basicGradeStatus === 5
              "
            >
              {{ $t('public.checkPending') }}
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :width="700"
      :title="$t('grades.editWeek')"
      v-model="weekModalVisible"
      :confirmLoading="weekModalLoading"
      :afterClose="weekAfterClose"
      @ok="weekOk"
    >
      <a-form
        :form="weekForm"
        :labelCol="{ span: $i18n.locale === 'zh_CN' ? 4 : 6 }"
        :wrapperCol="{ span: $i18n.locale === 'zh_CN' ? 19 : 17 }"
      >
        <a-form-item :label="$t('grades.weeks')">
          <a-checkbox-group v-decorator="['weeks']">
            <a-row style="margin-top: 5px">
              <a-col
                v-for="item in weekList"
                :key="item.id"
                :span="12"
                style="padding: 5px 0"
              >
                <a-checkbox
                  :disabled="weeksSubmited.includes(item)"
                  :value="item.id"
                >
                  {{ item.weeks }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :title="$t('public.edit', { content: '' })"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form :form="form">
        <a-form-item
          :label="$t('grades.attendance')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-input-number
            :min="0"
            :max="100"
            :step="0.1"
            :precision="1"
            v-decorator="['attendance']"
          />
        </a-form-item>

        <a-form-item
          :label="$t('grades.assignments')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-input-number
            :min="0"
            :max="100"
            :step="0.1"
            :precision="1"
            v-decorator="['assignments']"
          />
        </a-form-item>

        <a-form-item
          :label="$t('grades.participation')"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-input-number
            :min="0"
            :max="100"
            :step="0.1"
            :precision="1"
            v-decorator="['participation']"
          />
        </a-form-item>

        <a-form-item
          :label="$t('public.comments')"
          :extra="`${
            form.getFieldValue('comment')
              ? form.getFieldValue('comment').length
              : '0'
          }/1000`"
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-textarea
            :maxLength="1000"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="['comment']"
          >
          </a-textarea>
        </a-form-item>

        <a-alert
          v-if="basicGradeStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        />
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    classId: {
      type: [String, Number],
      required: true,
    },
    courseId: {
      type: [String, Number],
      required: true,
    },
    academic: {
      type: [String, Number],
      required: true,
    },
    semester: {
      type: [String, Number],
      required: true,
    },
    grade: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      weekTableLoading: false,
      weekDataSource: [],
      weeksSubmited: [],

      // 编辑教学周
      weekModalVisible: false,
      weekModalLoading: false,
      weekForm: this.$form.createForm(this),
      weekId: undefined,
      weekInfo: {},
      submitDisabled: true,

      // 学生
      editGrades: false,
      studentTableLoading: false,
      oldStudentDataSource: [],
      studentDataSource: [],
      editStudentDataSource: [],
      studentId: undefined,
      gradeId: undefined,
      basicGradeStatus: false,

      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
      },

      // weekList: [
      //   'Week1（Feb.10 - Feb.16）',
      //   'Week2（Feb.17 - Feb.23）',
      //   'Week3（Feb.24 - Mar.1）',
      //   'Week4（Mar.2 - Mar.8）',
      //   'Week5（Mar.9 - Mar.15）',
      //   'Week6（Mar.16 - Mar.22）',
      //   'Week7（Mar.23 - Mar.29）',
      //   'Week8（Mar.30 - Apr.5）',
      //   'Week9（Apr.6 - Apr.12）',
      //   'Week10（Apr.13 - Apr.19）',
      //   'Week11（Apr.20 - Apr.26）',
      //   'Week12（Apr.27 - May.3）',
      //   'Week13（May.4 - May.10）',
      //   'Week14（May.11 - May.17）',
      //   'Week15（May.18 - May.24）',
      //   'Week16（May.25 - May.31）',
      //   'Week17（Jun.1 - Jun.7）',
      //   'Week18（Jun.8 - Jun.14）',
      //   'Week19（Jun.15 - Jun.21）',
      //   'Week20（Jun.22 - Jun.28）',
      //   'Week21（Jun.29 - Jul.5）',
      //   'Week22（Jul.6 - Jul.12）',
      //   'Week23（Jul.13 - Jul.19）',
      //   'Week24（Jul.20 - Jul.26）',
      //   'Week25（Jul.27 - Aug.2）',
      //   'Week26（Aug.3 - Aug.9）',
      //   'Week27（Aug.10 - Aug.16）',
      //   'Week28（Aug.17 - Aug.23）',
      //   'Week29（Aug.24 - Aug.30）',
      //   'Week30（Aug.31 - ）'
      // ]
      weekList: [
        'Week1（SEP.14 - SEP.20）',
        'Week2（SEP.21 - SEP.27）',
        'Week3（SEP.28 - OCT.4）',
        'Week4（OCT.5 - OCT.11）',
        'Week5（OCT.12 - OCT.18）',
        'Week6（OCT.19 - OCT.25）',
        'Week7（OCT.26 - NOV.1）',
        'Week8（NOV.2 - NOV.8）',
        'Week9（NOV.9 - NOV.15）',
        'Week10（NOV.16 - NOV.22）',
        'Week11（NOV.23 - NOV.29）',
        'Week12（NOV.30 - DEC.6）',
        'Week13（DEC.7 - DEC.13）',
        'Week14（DEC.14 - DEC.20）',
        'Week15（DEC.21 - DEC.27）',
        'Week16（DEC.28 - JAN.3）',
        'Week17（JAN.4 - JAN.10）',
        'Week18（JAN.11 - JAN.17）',
        'Week19（JAN.18 - JAN.24）',
        'Week20（JAN.25 - JAN.31）',
        'Week21（FEB.1 - FEB.7）',
        'Week22（FEB.8 - FEB.14）',
        'Week23（FEB.15 - FEB.21）',
        'Week24（FEB.22 - FEB.28）',
      ],
    }
  },

  computed: {
    ...mapGetters(['handleRightsList']),
    propsChange() {
      return {
        classId: this.classId,
        courseId: this.courseId,
      }
    },
  },

  watch: {
    propsChange() {
      this.getWeek()
      // this.getBasicStudentDataSource()
      // this.getWeekListData()
    },
    weekId() {
      this.weekId && this.getBasicStudentDataSource()
    },
  },

  created() {
    this.getWeek()
    this.getWeekListData()
  },

  methods: {
    getWeekListData() {
      this.$http(this.$api.getWeekListAll, {
        academic: this.academic,
        semester: this.semester,
      }).then((r) => {
        this.weekList = r.data || []
      })
    },
    // 教学周
    getWeek() {
      this.weekTableLoading = true
      this.$http(this.$api.getWeekListAll, {
        academic: this.academic,
        semester: this.semester,
        classId: this.classId,
        courseId: this.courseId,
      }).then((r) => {
        this.weekTableLoading = false
        this.weekDataSource = r.data || []
        if (this.weekDataSource.length > 0) {
          if (this.weekId) {
            let haveWeek = false
            for (const item of this.weekDataSource) {
              if (item.id === this.weekId) {
                haveWeek = true
              }
            }
            if (!haveWeek) {
              this.weekInfo = this.weekDataSource[0]
              this.weekId = this.weekDataSource[0].id
              this.submitDisabled = this.weekDataSource[0].submitStatus === 1
            } else {
              let flagData = this.weekDataSource.find((Element) => {
                return this.weekId === Element.id
              })
              this.submitDisabled = flagData.submitStatus == 1
            }
          } else {
            this.weekInfo = this.weekDataSource[0]
            this.weekId = this.weekDataSource[0].id
            this.submitDisabled = this.weekDataSource[0].submitStatus === 1
          }
        } else {
          this.weekInfo = {}
          this.weekId = undefined
          this.submitDisabled = false
        }
        this.getBasicStudentDataSource()
        // getBasicStudentDataSource
      })
    },

    handleWeek() {
      this.weekModalVisible = true
      let weeks = []

      for (const item of this.weekDataSource) {
        weeks.push(item.weeks)

        if (item.submitStatus === 1) {
          this.weeksSubmited.push(item.weeks)
        }
      }

      this.$nextTick().then(() => {
        this.weekForm.setFieldsValue({
          weeks,
        })
      })
    },

    weekOk() {
      this.weekForm.validateFields((err, values) => {
        if (!err) {
          this.handleSaveWeek(values)
        }
      })
    },

    handleSaveWeek(values) {
      this.weekModalLoading = true
      this.$http(this.$api.UPDATEWEEK, {
        classId: this.classId,
        courseId: this.courseId,
        weeks: JSON.stringify(values.weeks),
        academic: this.academic,
        semester: this.semester,
        grade: this.grade,
      })
        .then(() => {
          this.getWeek()
          this.$message.success(this.$t('public.saveSuccess'))
          this.weekModalVisible = false
        })
        .catch(() => {
          this.weekModalLoading = false
        })
    },

    weekAfterClose() {
      this.weekForm.resetFields()
      this.weeksSubmited = []
      this.weekModalLoading = false
    },

    // 班级里学生
    getBasicStudentDataSource() {
      this.studentTableLoading = true
      this.$http(this.$api.GETBASICGRADEBYCLASSID, {
        weekId: this.weekId,
        courseId: this.courseId,
        classId: this.classId,
        academic: this.academic,
        semester: this.semester,
      }).then((r) => {
        this.studentDataSource = r.data || []
        this.oldStudentDataSource = JSON.parse(
          JSON.stringify(this.studentDataSource)
        )
        this.studentDataSource = this.studentDataSource.map((item) => {
          return Object.assign(item, {
            basicGrade: item.basicGrade
              ? item.basicGrade
              : {
                  basicGradeStatus: 0,
                },
          })
        })
        this.studentTableLoading = false
      })
    },

    handleEdit() {
      this.editGrades = true

      this.editStudentDataSource = [...this.studentDataSource]
    },

    handleChange(value, key, column) {
      const newData = [...this.studentDataSource]
      const target = newData.filter((item) => key === item.id)[0]

      if (target) {
        target.basicGrade = target.basicGrade || {}
        target.basicGrade[column] = value
        const editStudentDataSource = this.editStudentDataSource.filter(
          (item) => {
            return key === item.id
          }
        )[0]

        if (editStudentDataSource) {
          this.editStudentDataSource = this.editStudentDataSource.map(
            (item) => {
              if (item.id === key) {
                return target
              } else {
                return item
              }
            }
          )
        } else {
          this.editStudentDataSource.push(target)
        }

        this.studentDataSource = newData
      }
    },

    handleSaveGrades() {
      // let isEmpty = false
      // for (const item of this.editStudentDataSource) {
      //   if (
      //     Object.prototype.toString.call(item.basicGrade.attendance) ===
      //       '[object Null]' ||
      //     Object.prototype.toString.call(item.basicGrade.assignments) ===
      //       '[object Null]' ||
      //     Object.prototype.toString.call(item.basicGrade.participation) ===
      //       '[object Null]'
      //   ) {
      //     isEmpty = true
      //   }
      // }

      // if (!isEmpty) {
      this.editGrades = false
      this.submitDisabled = true
      this.studentTableLoading = true
      // let saveNumber = this.editStudentDataSource.length
      this.$message.warning(this.$t('grades.waitSave'))
      let studentDataList = new Array()
      for (const item of this.editStudentDataSource) {
        let listItem = {
          studentId: item.id,
          weekId: this.weekId,
          semester: this.semester,
          academic: this.academic,
          courseId: this.courseId,
          participation: item.basicGrade.participation
            ? item.basicGrade.participation
            : item.basicGrade.participation == 0
            ? 0
            : 100,
          assignments: item.basicGrade.assignments
            ? item.basicGrade.assignments
            : item.basicGrade.assignments == 0
            ? 0
            : 100,
          attendance: item.basicGrade.attendance
            ? item.basicGrade.attendance
            : item.basicGrade.attendance == 0
            ? 0
            : 100,
          comment: item.basicGrade.comment,
        }
        studentDataList.push(listItem)
        // this.$http(this.$api.EDITBASIGRADE, {
        //   studentId: item.id, //学生ID
        //   weekId: this.weekId,
        //   participation: item.basicGrade.participation
        //     ? item.basicGrade.participation
        //     : item.basicGrade.participation == 0
        //     ? 0
        //     : 100,
        //   assignments: item.basicGrade.assignments
        //     ? item.basicGrade.assignments
        //     : item.basicGrade.assignments == 0
        //     ? 0
        //     : 100,
        //   attendance: item.basicGrade.attendance
        //     ? item.basicGrade.attendance
        //     : item.basicGrade.attendance == 0
        //     ? 0
        //     : 100,
        //   comment: item.basicGrade.comment
        // })
        //   .then(() => {
        //     if (--saveNumber === 0) {
        //       this.editStudentDataSource = []
        //       this.submitDisabled = false
        //       this.getBasicStudentDataSource()
        //       console.log(222222)
        //       this.$message.success(this.$t('public.saveSuccess'))
        //     }
        //   })
        //   .catch(() => {
        //     this.editStudentDataSource = []
        //     this.submitDisabled = false
        // })
      }

      this.$http(this.$api.EDITBASIGRADE, {
        classId: this.classId,
        data: JSON.stringify(studentDataList),
      })
        .then(() => {
          // if (--saveNumber === 0) {
          this.editStudentDataSource = []
          this.submitDisabled = false
          this.getBasicStudentDataSource()
          this.$message.success(this.$t('public.saveSuccess'))
          // }
        })
        .catch(() => {
          this.editStudentDataSource = []
          this.submitDisabled = false
        })
      // } else {
      //   this.$message.warning(this.$t('grades.emptyGrade'))
      // }
    },

    handleCancel() {
      this.editGrades = false
      this.editStudentDataSource = []
      this.studentDataSource = JSON.parse(
        JSON.stringify(this.oldStudentDataSource)
      )
    },

    // 提交成绩
    handleSubmit() {
      this.$confirm({
        title: this.$t('handle.submit'),
        content: this.$t('report.submitGradeTip'),
        onOk: () => {
          this.submitGrade()
        },
        onCancel() {},
      })
    },

    submitGrade() {
      this.submitDisabled = true
      this.$http(this.$api.SUBMITBASIGRADE, {
        classId: this.classId,
        weeksId: this.weekId,
        courseId: this.courseId,
      })
        .then(() => {
          this.getWeek()
          this.getBasicStudentDataSource()
          this.$emit('submit-grades')
          this.$message.success(this.$t('public.saveSuccess'))
        })
        .catch(() => {
          this.submitDisabled = false
        })
    },

    editItem(record) {
      console.log(record)
      this.studentId = record.id
      this.gradeId = record.basicGrade.id
      this.modalVisible = true
      this.basicGradeStatus =
        record.basicGrade.basicGradeStatus === 1 ||
        record.basicGrade.basicGradeStatus === 2 ||
        record.basicGrade.basicGradeStatus === 4
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          participation: record.basicGrade.participation,
          assignments: record.basicGrade.assignments,
          attendance: record.basicGrade.attendance,
          comment: record.basicGrade.comment,
        })
      })
    },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true
      if (this.basicGradeStatus) {
        this.$http(this.$api.REEDITBASIGRADE, {
          id: this.gradeId,
          courseId: this.courseId,
          participation: values.participation,
          assignments: values.assignments,
          attendance: values.attendance,
          comment: values.comment,
        })
          .then(() => {
            this.getBasicStudentDataSource()
            this.$message.success(this.$t('public.sendSuccess'))
            this.modalVisible = false
          })
          .catch(() => {
            this.modalLoading = false
          })
      } else {
        this.$http(this.$api.EDITBASIGRADE, {
          classId: this.classId,
          data: JSON.stringify([
            {
              studentId: this.studentId, //学生ID
              weekId: this.weekId,
              semester: this.semester,
              academic: this.academic,
              participation: values.participation,
              assignments: values.assignments,
              attendance: values.attendance,
              comment: values.comment,
              courseId: this.courseId,
            },
          ]),
        })
          .then(() => {
            this.getBasicStudentDataSource()
            this.$message.success(this.$t('public.saveSuccess'))
            this.modalVisible = false
          })
          .catch(() => {
            this.modalLoading = false
          })
      }
    },

    afterClose() {
      this.form.resetFields()
      this.studentId = undefined
      this.gradeId = undefined
      this.modalLoading = false
    },
    //学号排序
    sorterStudentNo(a, b) {
      return (
        parseInt(a.studentNo.substring(a.studentNo.length - 3)) -
        parseInt(b.studentNo.substring(b.studentNo.length - 3))
      )
    },
    //英文排序
    sorterEnglishName(a, b) {
      return (a.englishName + '').localeCompare(b.englishName + '')
    },
    //中文排序
    sorterName(a, b) {
      return (a.givenName + '').localeCompare(b.givenName + '')
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.the-regular-basic {
  min-height: calc(100% - 91px);
  display: flex;
  @timetableTypeWidth: 200px;
  .left-wrap {
    padding: 15px 5px;
    width: @timetableTypeWidth;
    border-right: 1px solid @lineColor;
    text-align: center;
    height: calc(100vh - 240px);
    overflow-y: scroll;
    overflow-x: hidden;
    .left-title {
      font-size: @titleFontSize;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  .left-wrap::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

    height: 1px;
  }

  .left-wrap::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 10px;

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    background: #d3d3d3;
  }

  .left-wrap::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    border-radius: 10px;

    background: #ededed;
  }
  .right-wrap {
    padding: 15px;
    width: calc(~'100% - @{timetableTypeWidth}');
    display: flex;
    flex-direction: column;
    .grade-title {
      font-size: @titleFontSize;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.the-regular-basic {
  .subject-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
}
</style>
